export const environment = {
  production: true,
  apiUrl: "https://uk-api.equinemedirecord.com/api/v1",
  socketUrl: "https://uk-api.equinemedirecord.com",
  socketPort: ":6001",
  maxImgCount: 5,
  maxImgSize: "20971520", // in bytes
  defaultLanguage: "en",
  languages: [],
  country: "uk",
  availableCountries: {
    ireland: "https://app.equinemedirecord.com",
    uk: "https://uk-app.equinemedirecord.com",
    france: "https://fr.equinemedirecord.com",
    usa: "https://us.equinemedirecord.com",
    sa: "https://sa.equinemedirecord.com",
  },
  stripeKey: "pk_live_6CHopFnJyyVAjqJcdqrMl9bg00rJbNmHhd",
  quick_treatment: false,
  currency: "GBP",
  showRegionsSelect: true, //only for USA
  ruleBookPdf: null,
  ruleBookKYPdf: null,
  ruleBookCAPdf: null,
  ruleBookBCPdf: null,
  ruleBookBCPdPopup: null,
  ruleBookBC2023Pdf: null,
  ruleBookBC2023PdfPopup: null,
  insurancePdfPopup: "/assets/insurancePdfPopup.pdf",  
  filterRegionForDrugs: false,
  showModalUnvaccinated: true,
  showInTheFoodChainToggle: true,
  dateFormat: "dd/MM/yyyy",
  disableTreatmentEditInstructorNotOwned: false, //If set to true instructor (trainer) can not edit treatments not created by him.
  currentCountry: "uk",
  vaccinationCountries: ["ie", "fr"],
  ruleBookPCPdf: "",
  ruleBookPCPopup: "",
  ruleBookPKPdf: "",
  ruleBookPKPdfPopup: "",
  vaccinationDocumentUrl: "",
  kaynaPlatformId: "c497fee6-0ca0-4693-a861-6a422bfaa94b",
  kaynaWidgetUrl: "https://widget-uk.kayna.io/kayna.js"
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/environments/environment.ts